export const colors = [
  ["прозрачный", "#f0f0f0", "transparent"],
  ["матовый", "#fafafa", "matte"],
].map(([name, value, group]) => ({ name, value, group }));

export function groupOfColor(name) {
  return colors.find((c) => c.name === name)?.group;
}

export function colorsOfGroup(groupName) {
  return colors.filter((c) => c.group === groupName);
}
